import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Icons from 'consts/icons';
import InsideLoader from 'components/common/InsideLoader';
import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  Approvals: {
    marginTop: theme.spacing(2),
    '&__liveDataWrapper': {
      marginTop: 18.72,
    },
    '&__details': {
      padding: theme.spacing(3),
      '&__button': {
        '&__label': {
          '&--width': {
            width: 'initial',
          },
        },
      },
    },
    '&__loader': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 150,
      padding: 20,
      width: '100%',
      '&__error': {
        padding: 10,
        textAlign: 'center',
      },
      '&--color': {
        '&--warning': {
          color: theme.palette.warning.main,
        },
      },
      '&--height': {
        height: '50px',
      },
      '&--justify-content': {
        justifyContent: 'space-between',
      },
      '&--min-height': {
        minHeight: 'unset !important',
      },
    },
  },
}));

const Loader = props => {
  const { subtitles } = props;

  const [timeOut, setTimeOut] = React.useState(false);
  const [timeOutError, setTimeOutError] = React.useState(false);

  const classesApprovals = styles();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setTimeOut(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  React.useEffect(() => {
    const timerError = setTimeout(() => {
      setTimeOutError(true);
    }, 30000);
    return () => clearTimeout(timerError);
  }, []);

  return (
    <div
      className={`${classesApprovals.Approvals}__loader ${classesApprovals.Approvals}__loader--justify-content`}
    >
      <div>
        {timeOutError ? (
          <Icons.Navigation.ResetWarning
            size={50}
            className={`${classesApprovals.Approvals}__loader--color--warning`}
          />
        ) : (
          <InsideLoader />
        )}
      </div>
      <div className={`${classesApprovals.Approvals}__loader__error`}>
        <div>
          {timeOutError ? subtitles.loaderError_ : timeOut && subtitles.loader_}
        </div>
      </div>
    </div>
  );
};

Loader.propTypes = {
  subtitles: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  subtitles: state.language,
});

export default connect(mapStateToProps)(Loader);
